import React from 'react';
import * as asyncLoad from '../util/asyncLoad';
import { WeaTools, WeaDialog, WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import { emailFiles } from '../constants/fileConfig';

export default class SendEmail extends React.Component{
    constructor(){
        super();
        this.state = {hasLoad: false};
    }
    componentDidMount(){
        const init = () =>{
            this.setState({hasLoad:true});
        }
        asyncLoad.asyncLoadModule('email', emailFiles, init);
    }
    render(){
        const { hasLoad } = this.state;
        if(hasLoad){
            const { EmailNewForDialog : SendEmail } = window.weaEmail.components || {};
            const { visible = false,fwquery = {},closeFun = ()=>{} } = this.props;
            return (
                <SendEmail ecId={`${this && this.props && this.props.ecId || ''}_SendEmail@i0gfzw`} visible={visible} fwquery={fwquery} fromCb={true} style={{'height':'500px'}} onCancel={()=>{
closeFun()
}} />
            );
        }else{
            return (<div></div>);
        }
        
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/asyncComps/SendEmail.js